if (!customElements.get('livia-installments')) {
  customElements.define(
    'livia-installments',
    class LiviaInstallments extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-installments-open]');
        this.closeButton = this.querySelector('[data-installments-close]');
        this.dialog = this.querySelector('[data-installments-dialog]');

        if (!this.openButton || !this.dialog) return;

        this.handleOpen = () => this.dialog.showModal();
        this.handleClose = () => this.dialog.close();
        this.handleBackdropClick = (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          const outside =
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom;

          if (outside) this.dialog.close();
        };

        this.openButton.addEventListener('click', this.handleOpen);
        this.closeButton?.addEventListener('click', this.handleClose);
        this.dialog.addEventListener('click', this.handleBackdropClick);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.handleOpen);
        this.closeButton?.removeEventListener('click', this.handleClose);
        this.dialog?.removeEventListener('click', this.handleBackdropClick);
      }
    }
  );
}
